const is =
  (type: string) =>
  (mimeType: string | undefined): boolean =>
    mimeType ? mimeType.startsWith(type) : false;

export const isApplicationMimeType = is('application/');
export const isAudioMimeType = is('audio/');
export const isFontMimeType = is('font/');
export const isImageMimeType = is('image/');
export const isMessageMimeType = is('message/');
export const isModelMimeType = is('model/');
export const isMultipartMimeType = is('multipart/');
export const isTextMimeType = is('text/');
export const isVideoMimeType = is('video/');
